// Override blog author information to always show Marlène
document.addEventListener('DOMContentLoaded', function() {
  // Only run on blog article pages
  if (window.location.pathname.includes('/blogs/')) {
    // Replace author images
    const authorImages = document.querySelectorAll('.article__author img, .article__author-image');
    if (authorImages.length > 0) {
      authorImages.forEach(img => {
        img.src = window.theme.assets.image_auteur_marlene2;
        img.alt = 'Marlène';
        img.style.display = 'block';
        img.style.width = '60px';
        img.style.height = '60px';
        img.style.borderRadius = '100%';
      });
    } else {
      // If no author images found, try to find the footer and insert our custom author block
      const articleFooter = document.querySelector('.article__footer');
      if (articleFooter) {
        // Create author block if it doesn't exist
        if (!articleFooter.querySelector('.article__author')) {
          const authorDiv = document.createElement('div');
          authorDiv.className = 'article__author';
          authorDiv.innerHTML = `
            <img src="${window.theme.assets.image_auteur_marlene2}" alt="Marlène" class="article__author-image" style="display: block !important; width: 60px !important; height: 60px !important; border-radius: 100% !important;" />
            <div class="v-stack gap-3 justify-items-start">
              <p class="h6">${window.theme.strings.written_by.replace('{author}', 'Marlène')}</p>
            </div>
          `;
          articleFooter.prepend(authorDiv);
        }
      }
    }
    
    // Replace author names in text
    document.querySelectorAll('.article__author .h6').forEach(el => {
      if (el.textContent.includes('Written by') || el.textContent.includes('Écrit par')) {
        el.textContent = el.textContent.replace(/Written by [^,]+/, 'Written by Marlène');
        el.textContent = el.textContent.replace(/Écrit par [^,]+/, 'Écrit par Marlène');
      }
    });
  }
}); 